import { render, staticRenderFns } from "./setPasswrod.vue?vue&type=template&id=4071775f&"
import script from "./setPasswrod.vue?vue&type=script&lang=js&"
export * from "./setPasswrod.vue?vue&type=script&lang=js&"
import style0 from "./setPasswrod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports